"use client";

import React from "react";

//Type
import { AlertModalProps } from "@/types";

//Styled
import * as S from "./styles";

//Components
import { AlertDialogHeader } from "@/components/ui/alert-dialog";

//Icons
import { AlertCircle, AlertTriangle, CheckCircle2, X } from "lucide-react";

const AlertModal: React.FC<AlertModalProps> = ({
  open,
  onOpenChange,
  messageAlert,
  confirm,
  cancel,
  textConfirm = "Sim",
  icon,
  typeAlert = "danger",
  confirmWidth = false,
  descriptionAlert,
  isLoading = false,
}) => {
  const getDefaultIcon = () => {
    switch (typeAlert) {
      case "success":
        return <CheckCircle2 size={24} />;
      case "warning":
        return <AlertTriangle size={24} />;
      default:
        return <AlertCircle size={24} />;
    }
  };

  const displayIcon = icon || getDefaultIcon();

  return (
    <S.ModalAlert open={open} onOpenChange={onOpenChange}>
      <S.ModalContent>
        <S.ContentWrapper>
          <div style={{ position: "relative" }}>
            <AlertDialogHeader>
              <S.IconContainer $color={typeAlert}>
                {displayIcon}
              </S.IconContainer>
              <S.ModalTitle>{messageAlert}</S.ModalTitle>
              {descriptionAlert && (
                <S.ModalDescription>{descriptionAlert}</S.ModalDescription>
              )}
            </AlertDialogHeader>

            {/* Close button (X) - always shown to allow immediate close */}
            {onOpenChange && (
              <button
                aria-label="Fechar alerta"
                onClick={() => onOpenChange(false)}
                style={{
                  position: "absolute",
                  top: 6,
                  right: 6,
                  background: "transparent",
                  border: "none",
                  padding: 4,
                  cursor: "pointer",
                }}
              >
                <X size={18} />
              </button>
            )}
          </div>
        </S.ContentWrapper>
        <S.FooterModal>
          {cancel && (
            <S.ButtonCancel onClick={cancel} disabled={isLoading}>
              Não
            </S.ButtonCancel>
          )}
          <S.ButtonAction
            onClick={confirm}
            $color={typeAlert}
            $confirmWidth={confirmWidth}
            $hasCancel={!!cancel}
            disabled={isLoading}
          >
            {textConfirm}
          </S.ButtonAction>
        </S.FooterModal>
      </S.ModalContent>
    </S.ModalAlert>
  );
};

export default AlertModal;
